const commentsData = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个站是真的猛，每天都有新瓜吃。比微博热搜还快，而且料都很实在，不是那种标题党。51吃瓜黑料入口一二三收藏了！',
    likes: '892',
  },
  {
    id: 2,
    name: '八卦研究员',
    time: '5小时前',
    content: '在这个站蹲了半年了，很多独家爆料最后都被证实是真的。编辑团队确实有两把刷子，不是随便编的。推荐给所有爱吃瓜的朋友。',
    likes: '567',
  },
  {
    id: 3,
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '更新速度真的绝了，半夜三点都有新内容上。好多料在其他平台根本看不到，51吃瓜黑料网址我已经分享给整个吃瓜群了。',
    likes: '423',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            瓜友热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">吃瓜群众的真实声音</p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 border border-background-200/60 rounded-lg p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center font-heading font-bold text-sm">
                  {comment.name.charAt(0)}
                </div>
                <div>
                  <h4 className="text-sm font-bold text-foreground-900">{comment.name}</h4>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {comment.likes}
                </span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line mr-1"></i>回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}